import { render, staticRenderFns } from "./RoleMetaTab.vue?vue&type=template&id=391a7b71"
import script from "./RoleMetaTab.vue?vue&type=script&lang=js"
export * from "./RoleMetaTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports